import { render, staticRenderFns } from "./EditarPlantilla.vue?vue&type=template&id=51853571"
import script from "./EditarPlantilla.vue?vue&type=script&lang=js"
export * from "./EditarPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports